import pic1 from "../assets/img/about/about-5.jpg";
import pic2 from "../assets/img/about/about-3.jpg";
import pic3 from "../assets/img/about/about-4.jpg";
import pic4 from "../assets/img/about/about.jpg";
import pic5 from "../assets/img/about/about-2.jpg";
import pic6 from "../assets/img/about/about-6.jpg";
import pic7 from "../assets/img/about/about-7.jpg";
import pic8 from "../assets/img/about/about-8.jpg";

const aboutPic = [
  {
    image: pic1,
  },
  {
    image: pic2,
  },
  {
    image: pic3,
  },
  {
    image: pic4,
  },

];
const cusPic =[
      {
    image: pic5,
  },
  {
    image: pic6,
  },
  {
    image: pic7,
  },
  {
    image: pic8,
  },
];

export { aboutPic, cusPic };
